<template>
  <main v-if="updates">
    <div class="row">
      <div class="col s12 l10 offset-l1 card-panel recargas" style="margin-bottom: 5rem">
        <div class="row center-align" style="margin-bottom: 0%;">
          <div class="page-title">
            <span :style="`color: #149183;`" >{{ updates.tittle }} </span>
            <br>
            <span :style="`color: #149183;`">{{ updates.date }} </span>
          </div>
        </div>
        <div class="row">
          <div class="col offset-l2 l8">
            <div v-for="description in updates.descriptions" v-html="description"></div>
          </div>
        </div>

        <div  class="row" v-for="section in updates.sections">
          <div class="col offset-l2 l8">
            <div class="page-title">
              <span :style="`color: #149183;`" >{{ section.tittle }} </span>
            </div>

            <lu>
              <div v-for="children in section.children">
                <li >{{ children.description }}</li>
                <img v-show="children.image" class="materialboxed" width="650" :src="`https://recarga-te.com/dist/updates/${updateId}/${children.image}`">
              </div>

            </lu>
          </div>
        </div>


      </div>
    </div>
  </main>
</template>

<script>

import listUpdates from "@/updates/listUpdates";
import {mapState} from "vuex";

export default {
  name: "actualizacionesDetalle",
  data(){
    return {
      updatefileName: null,
      updateId: null,
      updates : {}
    }
  },
  computed: {
    ...mapState(["image", "primaryColor", "backgroundColor", "permisos"]),
  },
  mounted() {
    this.$nextTick(()=>{
      this.updatefileName = listUpdates.find(u => u.id == this.$route.params.id ).file
      this.updateId = listUpdates.find(u => u.id == this.$route.params.id ).id
      if( this.updatefileName )
        this.updates = require(`../updates/${this.updatefileName}`).updates
      setTimeout(()=>{
        M.AutoInit()
      }, 500)

    })
  }
}
</script>

<style scoped>
.row {
  font-size: 18px !important;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.collection-item{
  cursor: pointer !important;
}

.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
  both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}


</style>